module.exports = __webpack_public_path__ + "img/logo_rectangle.d2ae4588.png";